module.exports = __webpack_public_path__ + "img/survey_active.75fdf9f6.svg";